import { BaseService } from "../../core/baseService";
import {
  ChatServiceInterface,
  MarkChatAsReadParams,
  ActiveChatSessionsPayload,
  ArchivedChatSessionsRequest,
  ArchivedChatSessionsResponse,
  ArchivedChatMessagesResponse,
} from "../types/chat.types";
import { ApiResult } from "../../core/types";

export class ChatService extends BaseService implements ChatServiceInterface {
  async getUnreadCount(): Promise<ApiResult<{ count: number }>> {
    return this.handleRequest<{ count: number }>(
      this.client.get("/api/admin/chat/unread-count"),
    );
  }

  async getActiveSessions(hotelId?: string): Promise<ApiResult<ActiveChatSessionsPayload>> {
    return this.handleRequest<ActiveChatSessionsPayload>(
      this.client.get("/api/admin/chat/active-sessions", {
        headers: hotelId ? { "X-Hotel-Id": hotelId } : undefined,
      }),
    );
  }

  async markChatAsRead(params: MarkChatAsReadParams): Promise<ApiResult<void>> {
    const { roomId } = params;
    return this.handleRequest<void>(
      this.client.post(`/api/admin/chat/${roomId}/mark-as-read`),
    );
  }

  async getArchivedSessions(
    params: ArchivedChatSessionsRequest
  ): Promise<ApiResult<ArchivedChatSessionsResponse>> {
    const queryParams = new URLSearchParams();
    if (params.dateFrom) queryParams.append("dateFrom", params.dateFrom);
    if (params.dateTo) queryParams.append("dateTo", params.dateTo);
    if (params.roomNumber) queryParams.append("roomNumber", params.roomNumber);
    if (params.page) queryParams.append("page", params.page.toString());
    if (params.pageSize)
      queryParams.append("pageSize", params.pageSize.toString());

    const queryString = queryParams.toString();
    const url = `/api/admin/chat/archive${queryString ? `?${queryString}` : ""}`;

    return this.handleRequest<ArchivedChatSessionsResponse>(
      this.client.get(url)
    );
  }

  async getArchivedMessages(
    qrTokenId: string,
    count?: number
  ): Promise<ApiResult<ArchivedChatMessagesResponse>> {
    const queryParams = count ? `?count=${count}` : "";
    return this.handleRequest<ArchivedChatMessagesResponse>(
      this.client.get(`/api/admin/chat/archive/${qrTokenId}${queryParams}`)
    );
  }
}
